import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/custodyAndPosition'
import { getCustodyAndPosition as getCustodyAndPositionService } from 'services'

const {
  CUSTODYANDPOSITION_REQUEST,
  CUSTODYANDPOSITION_SUCCESS,
  CUSTODYANDPOSITION_ERROR
} = ACTION_TYPES

export function *getCustodyAndPosition(payload) {
  try {
    const response = yield call(getCustodyAndPositionService, payload)
    yield put({ type: CUSTODYANDPOSITION_SUCCESS, payload: response.data })
  } catch (err) {
    yield put({ type: CUSTODYANDPOSITION_ERROR, payload: err })
  }
}

export default function *watchCustodyAndPosition() {
  yield takeLatest(CUSTODYANDPOSITION_REQUEST, getCustodyAndPosition)
}
